import PropTypes from 'prop-types';
import { Alert, Button, Stack, Typography } from '@mui/material';

// The dialer widget's finished state: "Did they answer?" for a call we can't read the result of
// (CU-869fmc59c). Same card, same buttons as the rest of the widget; the choices come from
// callFlowModel.askChoices and the answer goes to the call flow (useCallFlow().answerAsk).
export default function DialerOutcomeAsk({ choices, busy, locked, message, onChoose }) {
    return (
        <Stack spacing={1.25} data-testid="dialer-outcome-ask">
            <Typography variant="body2">Did they answer?</Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {choices.map((choice) => (
                    <Button
                        key={choice.id}
                        size="small"
                        variant={choice.primary ? 'contained' : 'outlined'}
                        disabled={busy || locked}
                        onClick={() => onChoose(choice.id)}
                        data-testid={`dialer-ask-${choice.id}`}
                    >
                        {choice.label}
                    </Button>
                ))}
            </Stack>
            {message && <Alert severity={locked ? 'warning' : 'error'} data-testid="dialer-ask-message">{message}</Alert>}
        </Stack>
    );
}

DialerOutcomeAsk.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired, primary: PropTypes.bool })).isRequired,
    busy: PropTypes.bool,
    locked: PropTypes.bool,
    message: PropTypes.string,
    onChoose: PropTypes.func.isRequired,
};
DialerOutcomeAsk.defaultProps = { busy: false, locked: false, message: '' };
